import { Dialog, IconButton, IconClose, BUTTON_VARIANTS } from 'cdk-radial';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { deleteBundle,storeDeletedBundleName } from '../../../../../redux/connectedComponent/orderAPI/orderAPI.slice';
import { useEffect } from 'react';
import { AMPLITUDE_EVENTS } from '../../../../../constants/amplitudeConstants';
import {
  getOrgAmplitudeProperties,
  sendAmplitudeData,
} from '../../../../../utils/amplitude';
import { trackManageApiIntegration } from '../../../../../utils/gtm';

const StyledDialog = styled(Dialog)`
  width: 711px;
  height: 190px;
`;

export const APIDeleteBundle = ({ isOpen, handleClose, data }) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { authenticationToken: token } = state?.loginDetailsSlice;
  const orgAmplitudeProperties = getOrgAmplitudeProperties(
    state?.loginDetailsSlice
  );
  const { orders, deletingBundle } =
    state?.orderAPISlice;
  const TITLE = 'Delete Bundle';

  const handleDeleteBundle = () => {
    dispatch(storeDeletedBundleName({ bundleName: data?.name }));
    const deleteBundleResult = dispatch(
      deleteBundle({
        orderId: orders?.app?.id,
        bundleId: data?.id,
        token,
      })
    );

    if (deleteBundleResult && typeof deleteBundleResult.then === 'function') {
      deleteBundleResult.then((action) => {
        if (deleteBundle.fulfilled.match(action)) {
          handleClose(true);
        } else if (deleteBundle.rejected.match(action)) {
          handleClose(false);
        }
      });
    }

    trackManageApiIntegration({
      actionType: 'Delete',
      bundleId: data?.id,
      bundleDisplayName: data?.name,
      isBundle: true,
    });

    sendAmplitudeData(
      AMPLITUDE_EVENTS.DELETE_BUNDLE_CONFIRMATION_DELETE,
      orgAmplitudeProperties
    );
  };

  const handleCancel = () => {
    handleClose(false);
  };

  return (
    <StyledDialog
      id="bundle-delete-dialog"
      isOpen={isOpen}
      onClose={handleCancel}
      hideHeader
      className="api-delete-dialog"
      buttonsProps={[
        {
          id: 'delete-bundle-cancel-button',
          onClick: handleCancel,
          text: 'Cancel',
          variant: BUTTON_VARIANTS.SECONDARY,
        },
        {
          id: 'delete-bundle-button',
          onClick: handleDeleteBundle,
          isLoading: deletingBundle,
          text: 'Delete',
          variant: BUTTON_VARIANTS.PRIMARY,
        },
      ]}
    >
      <h2 className="api-delete-dialog-warning-heading">
        {TITLE}
        <IconButton
          icon={<IconClose />}
          onClick={handleCancel}
          className="api-delete-close-icon"
          style={{ float: 'right' }}
        />
      </h2>
      <div className="api-delete-dialog-warning-message">
        There are <strong>active subscriptions</strong> to this bundle. Deleting this bundle
        integration will remove these subscriptions. Are you sure you want to
        continue?
      </div>
    </StyledDialog>
  );
};
